// extracted by mini-css-extract-plugin
module.exports = {"list":"NavList_list__3adXT","item":"NavList_item__F3nO8","link":"NavList_link__2iXQ2"};